module.exports = __webpack_public_path__ + "img/icons_34.27761f9e.png";